module.exports = function getResource(label, vars = []) {
    let resources = {
        beautyTraits: 'Atouts beauté',
        beautyTraitsInclude: 'Les traits de beauté sur votre profil comprennent :',
        skinType: 'Type de peau',
        skinTone: 'Teint',
        hairType: 'Type de cheveux',
        hairColor: 'Colorant capillaire',
        eyeColor: 'Couleur des yeux',
        colorIQ: 'Color IQ',
        beautyTraitsVisible: 'Qui peut voir les atouts beauté sur votre profil :',
        everyone: 'Tout le monde',
        justMe: 'Juste moi',
        profile: 'Profil',
        yourSkincareConcerns: 'Vos problèmes de peau et de cheveux n’apparaissent pas sur votre profil public.',
        yourProfileVisible: `Votre profil est visible pour : ${vars[0] ? 'Juste moi' : 'Tout le monde'}`,
        yourBeautyInsider: 'Vos pages Beauty Insider, Listes et Compte sont toujours privées.',
        forMoreInformation: 'Pour plus d’informations, consulter notre',
        termsOfUse: 'les conditions d’utilisation et les'
    };
    return resources[label];
};
